import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable()
export class ContentManagementService {
  api_url: string = environment.apiEndPoint;

  constructor(private http: HttpClient) {}

  getToken() {
    return localStorage.getItem(environment.TOKEN_SECRET);
  }

  geAllCms() {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.get<any>(this.api_url + "cms", configs);
  }
  saveCms(obj) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
      body: obj,
    };
    if (obj._id) {
      return this.http.put<any>(this.api_url + "cms/" + obj._id, obj, configs);
    }
    return this.http.post<any>(this.api_url + "cms", obj, configs);
  }
  deleteCms(obj) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
      body: obj,
    };
    return this.http.delete<any>(this.api_url + "cms/" + obj._id, configs);
  }
}



// WEBPACK FOOTER //
// ./src/app/content-management/content-management.service.ts